import React, { useCallback, useReducer } from 'react';
import { watchesReducer } from './watchesReducer';
import {
	ICreateWatchesData,
	TTypeOfModalWindow,
	WatchesContext,
	watchesInitialState,
	NEW_WATCHES_TABLE_RANGES_PREFIX,
	NEW_ADMIN_WATCHES_TABLE_RANGES_PREFIX,
} from './watchesContext';
import { WatchesActionsTypes } from './watchesAction';
import { TWatchesCommandsTypes } from 'types';

const WatchesState = ({ children }: JSX.ElementChildrenAttribute) => {
	const [state, dispatch] = useReducer(watchesReducer, watchesInitialState);

	const setWatchesQuantity = useCallback((value: null | number) => {
		if (value) {
			const newWatchesTableRanges = [];
			for (let i = 0; i < value; i++) {
				newWatchesTableRanges.push({ id: `${NEW_WATCHES_TABLE_RANGES_PREFIX}/${i}`, range: '' });
			}
			dispatch({
				type: WatchesActionsTypes.SET_WATCHES_QUANTITY,
				payload: {
					watchesQuantity: value,
					watchesTableRanges: newWatchesTableRanges,
				},
			});
		} else {
			dispatch({
				type: WatchesActionsTypes.SET_WATCHES_QUANTITY,
				payload: {
					watchesQuantity: value,
					watchesTableRanges: [],
				},
			});
		}
	}, []);

	const setAdminWatchesQuantity = useCallback((value: null | number) => {
		if (value) {
			const newAdminWatchesTableRanges = [];
			for (let i = 0; i < value; i++) {
				newAdminWatchesTableRanges.push({ id: `${NEW_ADMIN_WATCHES_TABLE_RANGES_PREFIX}/${i}`, range: '' });
			}
			dispatch({
				type: WatchesActionsTypes.SET_ADMIN_WATCHES_QUANTITY,
				payload: {
					adminWatchesQuantity: value,
					adminWatchesTableRanges: newAdminWatchesTableRanges,
				},
			});
		} else {
			dispatch({
				type: WatchesActionsTypes.SET_ADMIN_WATCHES_QUANTITY,
				payload: {
					adminWatchesQuantity: value,
					adminWatchesTableRanges: [],
				},
			});
		}
	}, []);

	const setCommands = useCallback((value: TWatchesCommandsTypes[]) => {
		dispatch({
			type: WatchesActionsTypes.SET_COMMANDS,
			payload: {
				commands: value,
			},
		});
	}, []);

	const changeWatchesTableRanges = useCallback(
		(rangeId: string, range: string) => {
			const updatedWatchesTableRanges = state.watchesTableRanges.map((el) =>
				el.id === rangeId ? { id: el.id, range } : el,
			);
			dispatch({
				type: WatchesActionsTypes.CHANGE_WATCHES_TABLE_RANGES,
				payload: {
					watchesTableRanges: updatedWatchesTableRanges,
				},
			});
		},
		[state.watchesTableRanges],
	);

	const changeAdminWatchesTableRanges = useCallback(
		(rangeId: string, range: string) => {
			const updatedAdminWatchesTableRanges = state.adminWatchesTableRanges.map((el) =>
				el.id === rangeId ? { id: el.id, range } : el,
			);
			dispatch({
				type: WatchesActionsTypes.CHANGE_ADMIN_WATCHES_TABLE_RANGES,
				payload: {
					adminWatchesTableRanges: updatedAdminWatchesTableRanges,
				},
			});
		},
		[state.adminWatchesTableRanges],
	);

	const setDataForSubmit = useCallback((value: ICreateWatchesData | null) => {
		dispatch({
			type: WatchesActionsTypes.SET_DATA_FOR_SUBMIT,
			payload: {
				dataForSubmit: value,
			},
		});
	}, []);

	const changeTypeOfModalWindow = useCallback((value: TTypeOfModalWindow) => {
		dispatch({
			type: WatchesActionsTypes.CHANGE_TYPE_OF_MODAL_WINDOW,
			payload: {
				typeOfModalWindow: value,
			},
		});
	}, []);

	return (
		<WatchesContext.Provider
			value={{
				setWatchesQuantity,
				setAdminWatchesQuantity,
				setCommands,
				changeWatchesTableRanges,
				changeAdminWatchesTableRanges,
				setDataForSubmit,
				changeTypeOfModalWindow,
				watchesQuantity: state.watchesQuantity,
				adminWatchesQuantity: state.adminWatchesQuantity,
				commands: state.commands,
				watchesTableRanges: state.watchesTableRanges,
				adminWatchesTableRanges: state.adminWatchesTableRanges,
				dataForSubmit: state.dataForSubmit,
				typeOfModalWindow: state.typeOfModalWindow,
			}}>
			{children}
		</WatchesContext.Provider>
	);
};

export default WatchesState;
